<template>
  <div>
    <h1>DealManager</h1>
    <p>Coming Soon...</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>